module.exports = __webpack_public_path__ + "img/attack_burningfield.1a8238a4.png";